export * from "./isMarketQA";